import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Enumerable from 'linq';
import { AssessmentViewModel, CEUEventSummary, ParticipationModality, QuizAnswerViewModel, QuizResponseViewModel } from 'src/app/_models/generatedModels';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { AssessmentService, CEUService, CourseService, EventService } from 'src/app/_services/generatedServices';
import { ToasterService } from 'src/app/_services/toaster.service';

@Component({
  selector: 'bxl-resolve-ceus-modal',
  templateUrl: 'resolve-ceus-modal.component.html',
})
export class ResolveCEUsModalComponent implements OnInit {
  initialized = false;
  rating: number = 0;
  resolve = false;
  courseEventId: number;
  @ViewChild('myForm') myForm: FormGroupDirective;
  ParticipationModality = ParticipationModality;
  selectedAnswers: QuizAnswerViewModel;

  @Input() courseEvent: CEUEventSummary;
  submitComplete: Promise<{}> | undefined;
  errorMessage: string;
  assessment: AssessmentViewModel;
  constructor(private assessmentService: AssessmentService, private toastr: ToasterService, private ceuService: CEUService, public auth: AuthenticationService, private modalService: NgbModal, public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    if (this.courseEvent.assessmentId) {
      this.assessmentService.getAssessment(this.courseEvent.assessmentId).subscribe((assessment) => {
        this.assessment = assessment;

        this.selectedAnswers = new QuizAnswerViewModel();
        this.selectedAnswers.responses = [];
        for (let i = 0; i < this.assessment.questions.length; i++) {
          var item = new QuizResponseViewModel();
          item.questionId = this.assessment.questions[i].id;
          this.selectedAnswers.responses.push(item);
        }

        console.log(this.selectedAnswers);
        this.initialized = true;
      });
    } else {
      this.initialized = true;
    }
  }

  public done(){
    this.activeModal.close();
  }

  public onSave() {
    if (!this.myForm.valid) {
      this.myForm.form.markAllControlsDirty();
      return;
    }

    this.ceuService.resolveCEUsWithQuiz(this.courseEventId, this.selectedAnswers).subscribe((result) => {
      this.activeModal.dismiss(result);
      this.toastr.success('CEUs Resolved', 'Success');
    }, (error) => {
      this.errorMessage = error.error[0];
    });

    console.log(this.selectedAnswers);
    console.log(this.assessment);
  }
}
